<template>
    <v-dialog
            persistent
            max-width="500px"
            v-model="opened"
    >
        <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>-->

        <v-toolbar dense dark color="red" >
            <v-toolbar-title>Login</v-toolbar-title>
        </v-toolbar>


            <v-card
                    :loading="loading"
                    :disabled="loading"
            >


                <v-container>

                    <v-card-text >

                        <!--
                        <v-layout
                                row
                                fill-height
                                justify-center
                                align-center
                                v-if="loading"
                        >
                            <v-progress-circular
                                    :size="50"
                                    color="red"
                                    indeterminate
                            />
                            In progress
                        </v-layout>
                        -->
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-text-field
                                    v-model="user.username"
                                    label="Login"
                                    name="login"
                                    :rules="rules.username"
                                    maxlength="70"
                                    required
                                    prepend-icon="mdi-account-circle"
                                    type="text"
                                    clearable
                            />

                            <v-text-field
                                    id="password"
                                    label="Password"
                                    name="password"
                                    v-model="user.password"
                                    :rules="rules.password"
                                    required
                                    :counter="20"
                                    @click:append="visible = !visible"
                                    :append-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                    :append-icon-cb="togglePassword"
                                    prepend-icon="mdi-lock"
                                    :type="visible ? 'text' : 'password'"
                            />
                        </v-form>
                    </v-card-text>


                    <v-card-actions>
                        <v-select :items="authProviders" label="domaine"></v-select>
                        <v-spacer />
                        <v-btn class="red white--text" :disabled="!valid" @click="login">Me connecter</v-btn>
                    </v-card-actions>

                </v-container>

            </v-card>
    </v-dialog>



</template>

<script>
    import User from '../../../models/user';
    //import CenteredBox from '../../templates/block/CenteredBox'


    export default {
        name: 'Login',
        components: {
        //    CenteredBox
        },
        props: {
            source: String,
        },
        data () {
            return {
                opened: true,
                user: new User('',''),
                loading:false,
                valid:true,
                visible: false,
                authProviders: ['basic','INSA'],
                rules: {
                    username: [
                        v => !!v || "Username is required",
                        v => (v && v.length > 3) || "A username must be more than 3 characters long",
                        v => /^[a-z0-9_]+$/.test(v) || "A username can only contain letters and digits"
                    ],
                    password: [
                        v => !!v || "Password is required",
                        v => (v && v.length > 2) || "The password must be longer than 7 characters"
                    ]
                }
            }

        },
        methods:{
            togglePassword (){
                this.visible= !this.visible;
                localStorage.setItem('connected', this.visible);
            },
            login() {
                // checking if the input is valid
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    console.log('ths + ',this)
                    let _this=this
                    this.$store.dispatch('auth/login', this.user).then(
                        (data) => {
                            console.log('ok', data)
                            /*
                            Swal.fire({
                                icon: 'success',
                                title: 'Welcome ' + this.user.username,
                                text: 'You have been authenticated with success \n' + JSON.stringify(data),
                                showConfirmButton:true,
                                showCloseButton:true,
                                timer:10000
                            }).then(()=>{
                                this.$router.push('/');
                            })
                            */
                            this.$router.push('/');


                        },
                        error => {
                            console.log('nok', error)
                            _this.loading = false;
                            let message =
                                (error.response && error.response.data) ||
                                error.message ||
                                error.toString();

                            console.error(message)
                            _this.loading = false;
                            /*
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: message.detail,
                                showConfirmButton:false,
                                showCloseButton:true,
                                timer:10000
                            })

                             */
                        }
                    );
                }
            }
        }
    }
</script>
<style>
    .v-input__icon {
        color: purple;
    }


</style>
